import {Link} from 'react-router';
import {useAcuerdosDePago, useEditarAcuerdo} from '../api/cashflow';
import {useFinanciadores} from '../api/financiacion';
import {tr} from '../i18n/idioma';
import {DEFINICION_ACUERDOS} from './columnas-cashflow';
import {usePermisos} from './sesion-contexto';
import {TablaDeCashflowComun} from './tabla-de-cashflow';

// Cashflow → Acuerdos: las condiciones de compra con cada proveedor tercero
// (hoja Input) y la linea de financiacion con que se pagan sus anticipos.
export function AcuerdosDePago() {
  const acuerdos = useAcuerdosDePago();
  const financiadores = useFinanciadores();
  const editar = useEditarAcuerdo();
  const permisos = usePermisos();
  const lineas = (financiadores.data ?? []).filter(f => f.financia);
  const lista = acuerdos.data?.acuerdos ?? [];
  return (
    <div className="space-y-3" data-prueba="cashflow-acuerdos">
      <p className="text-sm text-apagado">
        {tr(
          'La línea elegida aquí es con la que se pagan los anticipos de ese acuerdo; un pago puede tener otra (en Pagos a terceros). Con línea, los pagos pendientes se descuentan del cupo disponible en el Resumen.',
          'The line chosen here is the one used to pay that agreement’s advances; a payment can have another (in Third-party payments). With a line, pending payments are deducted from the available credit in the Summary.',
        )}{' '}
        <Link to="/configuracion-de-campos/financiadores" className="text-verde hover:underline">
          {tr('Financiadores y cupos', 'Financers and credit lines')}
        </Link>
      </p>
      {acuerdos.isError && <p className="text-sm text-alerta">{acuerdos.error.message}</p>}
      {editar.isError && <p className="text-sm text-alerta">{editar.error.message}</p>}
      <TablaDeCashflowComun
        tabla="acuerdos"
        hoja={tr('Acuerdos', 'Agreements')}
        definicion={DEFINICION_ACUERDOS}
        filas={lista}
        claveDeFila={a => a.codigo}
        altoMaximo="calc(100vh - 20rem)"
        mensajeVacio={
          acuerdos.isPending
            ? tr('Cargando…', 'Loading…')
            : tr(
                'Todavía no hay acuerdos: carga el Payment Schedule Third Parties.',
                'No agreements yet: load the Payment Schedule Third Parties.',
              )
        }
        celda={(columna, a) => {
          if (columna.id === 'codigo') return <span className="font-medium">{a.codigo}</span>;
          if (columna.id === 'linea' && permisos.editar)
            return (
              <select
                aria-label={tr(`Línea del acuerdo ${a.codigo}`, `Line of agreement ${a.codigo}`)}
                value={a.linea ?? ''}
                disabled={editar.isPending}
                onChange={e =>
                  editar.mutate({codigo: a.codigo, edicion: {version: a.version, linea: e.target.value || null}})
                }
                className="rounded-md border border-linea bg-white px-2 py-0.5 text-sm"
              >
                <option value="">{tr('Sin línea', 'No line')}</option>
                {lineas.map(l => (
                  <option key={l.codigo} value={l.codigo}>
                    {l.nombre} ({l.codigo})
                  </option>
                ))}
              </select>
            );
          return undefined;
        }}
      />
    </div>
  );
}
